import { FormField, OptionGroup } from '@dev-spendesk/grapes';

import { CustomFieldFormField } from 'common/components/CustomFieldFormField';
import { useTranslation } from 'common/hooks/useTranslation';
import { type RawCustomField } from 'modules/custom-fields/models/customField';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

import { type CustomFieldFiltersType } from './types';
import { useDesignatedCustomFieldQuery } from '../../hooks/useDesignatedCustomFieldQuery';

type Props = {
  filters: CustomFieldFiltersType;
  customField: RawCustomField;
  setFilters: (filters: CustomFieldFiltersType) => void;
  disableSelectUndefined?: boolean;
  className?: string;
};

export const CustomFieldFilter = ({
  customField,
  filters,
  setFilters,
  disableSelectUndefined,
  className,
}: Props) => {
  const { t } = useTranslation('global');

  const designatedCustomFieldState = useDesignatedCustomFieldQuery();
  const designatedCustomFieldId = unwrapQuery(
    designatedCustomFieldState,
  )?.customFieldId;

  const selectedValue = filters[customField.id];

  if (customField.type === 'boolean') {
    return (
      <FormField
        key={customField.id}
        className={className}
        label={
          customField.id === designatedCustomFieldId
            ? t('expenseCategories.requestPanel.expenseCategory')
            : customField.name
        }
        htmlFor="none"
      >
        <OptionGroup
          name="invoiceBooleanFilter"
          value={selectedValue?.key ?? null}
          onChange={(event) => {
            setFilters({
              ...filters,
              [customField.id]: {
                key: event.target.value,
                label: event.target.value,
              },
            });
          }}
          options={[
            {
              value:
                customField.custom_fields_values.find(
                  ({ value }) => value === '1',
                )?.id || '',
              label: t('misc.yes'),
            },
            {
              value:
                customField.custom_fields_values.find(
                  ({ value }) => value === '0',
                )?.id || '',
              label: t('misc.no'),
            },
          ]}
        />
      </FormField>
    );
  }

  return (
    <CustomFieldFormField
      key={customField.id}
      className={className}
      fit="parent"
      customField={customField}
      label={
        customField.id === designatedCustomFieldId
          ? t('expenseCategories.requestPanel.expenseCategory')
          : customField.name
      }
      placeholder={customField.name}
      customFieldAssociation={
        selectedValue
          ? {
              customFieldId: customField.id,
              customFieldValueId: selectedValue?.key ?? '',
              value: selectedValue?.label ?? '',
            }
          : undefined
      }
      disableCreateNewValue
      disableSelectUndefined={disableSelectUndefined}
      onSelectCustomFieldValue={(customFieldValue) => {
        setFilters({
          ...filters,
          [customField.id]: customFieldValue
            ? { key: customFieldValue.key, label: customFieldValue.name }
            : null,
        });
      }}
      onSelectNewCustomFieldValue={() => {}}
    />
  );
};
